<template>
  <div>
    <hshead title="申请城市" bgcolor="#fff"></hshead>
    <div class="side-box">
      <div class="side-left">
        <!-- <div class="side-li" @click="activeKey=index" :class="{'act':(index==activeKey)}" v-for="(item, index) in sideList" :key="'side'+index">广州</div> -->
        <div class="side-li" v-for="(item, index) in provinceList" :class="{'act':(index==activeProvinceIdx)}" :key="index" @click="proviceSelect(item, index)">
          {{item.label.length > 5 ? (item.label.substr(0,5) + '...') : item.label}}
        </div>
      </div>
      <div class="side-right">
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in cityList"
              clickable
              :key="index"
              :title="`${item.label}`"
              @click="toggle(index)"
            >
              <van-checkbox :name="item" ref="checkboxes" slot="right-icon" />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    <div class="bottom-btn-box">
      <router-link to='/Grapher/ShootCitys' class="bottom-btn nobg">取消</router-link>
      <div class="bottom-btn" @click="handleAddAuditShootCitys">确定</div>
    </div>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Sidebar, SidebarItem, Checkbox, CheckboxGroup, Cell, CellGroup } from "vant";
import { getCascaderData, addAuditShootCitys } from "@/api/m/shootCity";

export default {
  name: "applicantCity",
  data() {
    return {
      activeKey: 3,
      // sideList: ["", "", "", "", "", "", "", "", "", "", ""],
      // list: [
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c",
      //   "a",
      //   "b",
      //   "c",
      //   "c"
      // ],
      result: ["a"],
      //
      provinceList: null,
      cityList: null,
      //curSelectedCity: [],
      activeProvinceIdx: 0,
      topProvince: {
        label: '全国',
        value: '*',
        children: [{
          label: '全国可拍',
          value: '*',
          children: null,
          parentId: '*'
        }]
      }
    };
  },
  created() {
    //城市列表数据
    this.getCascaderData()
    //
    this.cityList = this.topProvince.children
  },
  methods: {
    toggle(index) {
      console.info('index', index)
      this.$refs.checkboxes[index].toggle();
      // if(this.$refs.checkboxes[index].checked == false) {
      //   this.curSelectedCity.push(this.cityList[index])
      // }
      // else {
      //   this.curSelectedCity = this.curSelectedCity.filter(w => w.value != this.cityList[index].value)
      // }
      if(index == 0) {
        if(this.$refs.checkboxes[index].checked == false) {
          //全部选中
          console.info('全部选中')
          this.cityList.map((item, idx) => {
            if(this.$refs.checkboxes[idx].checked == false) {
              this.$refs.checkboxes[idx].toggle();
            }
          })
        }
        else {
          //全部不选中
          console.info('全部不选中')
          this.cityList.map((item, idx) => {
            if(this.$refs.checkboxes[idx].checked == true) {
              this.$refs.checkboxes[idx].toggle();
            }
          })
        }
      }
    },
    //城市列表数据
    getCascaderData() {
      getCascaderData().then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getCascaderData -> data', data)          
          this.provinceList = [this.topProvince, ...data[0].children]
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    //
    proviceSelect(row, idx) {
      console.info('proviceSelect', row)
      this.activeProvinceIdx = idx
      //this.curSelectedCity = []
      if(row.label == '全国') {
        this.cityList = row.children
      }
      else {
        const topCity = {
          label: '全省可拍',
          value: '*',
          children: null,
          parentId: row.value
        }
        this.cityList = [topCity, ...row.children]
      }
    },
    handleAddAuditShootCitys() {
      let curSelectIdx = []
      this.$refs.checkboxes.map((item, idx) => {
        if(item.checked) curSelectIdx.push(idx)
      })
      console.info('curSelectIdx', curSelectIdx)
      if(curSelectIdx.length == 0) {
        this.tips('请选中城市')
      }
      else {
        const params = []
        if(curSelectIdx.indexOf(0) > -1) {
          params.push({
            ProvinceId: this.cityList[0].parentId,
            CityId: this.cityList[0].value
          })
        }
        else {
          this.cityList.map((item, idx) => {
            if(curSelectIdx.indexOf(idx) > -1) {
              params.push({
                ProvinceId: item.parentId,
                CityId: item.value
              })
            }
          })
        }
        console.info('params', params)
        this.load(true, '加载中...');
        addAuditShootCitys(params).then((response) => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips('申请成功')
            setTimeout(function(){
              window.location.href = '/Grapher/ShootCitys'
            }, 1000 * 1)
          }
        }).catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({duration:1000 * 5, message: `${response.msg}`});
        });
      }
    }
  },
  components: {
    hshead,
    "van-sidebar": Sidebar,
    "van-sidebar-item": SidebarItem,
    "van-checkbox-group": CheckboxGroup,
    "van-checkbox": Checkbox,
    "van-cell-group": CellGroup,
    "van-cell": Cell
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.side-box {
  display: flex;
  margin-bottom: 1.2rem;
  .side-left {
    width: 2rem;
    background-color: #eef2f5;
    height: 100%;
    .side-li {
      height: 1.2rem;
      background-color: #eef2f5;
      font-size: 0.26rem;
      text-align: center;
      color: #666666;
      line-height: 1.2rem;
      border-bottom: 1px solid #fff;
      &.act {
        border-left: 1px solid #3bb9ff;
        color: #0e9ceb;
        background: #fff;
        margin-right: -1px;
      }
    }
  }
  .side-right {
    flex: 1;
  }
}
.bottom-btn-box {
  width: 7.5rem;
  height: 0.98rem;
  background-color: #ffffff;
  box-shadow: 0rem -1px 0rem 0rem #e5e5e5;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 6;
  display: flex;
  justify-content: flex-end;
  .bottom-btn {
    width: 1.7rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.24rem;
    background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
      linear-gradient(#f2f9fb, #f2f9fb);
    background-blend-mode: normal, normal;
    border-radius: 0.3rem;
    display: block;
    color: #ffffff;
    margin-top: 0.2rem;
    &.nobg {
      border: solid 1px #00b8f5;
      background: transparent;
      color: #00b8f5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/applicantCity.vue